import { space } from '@sunwebgroup/ui-components'
import { Skeleton } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const PriceWrapperSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const PriceHeaderSkeleton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${space('primitives_space_8')};
  align-self: stretch;
`
const PriceSupportingTextSkeleton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${space('primitives_space_2')};
`

const PriceSkeleton = styled(Skeleton)`
  width: 122px;
  height: ${space('primitives_space_32')};
`

function PriceComponentLoading() {
  return (
    <PriceWrapperSkeleton>
      <PriceHeaderSkeleton>
        <Skeleton />
      </PriceHeaderSkeleton>
      <PriceSkeleton />
      <PriceSupportingTextSkeleton>
        <Skeleton />
      </PriceSupportingTextSkeleton>
    </PriceWrapperSkeleton>
  )
}

export const PriceLoading = styled(PriceComponentLoading)``
